import React from "react";
import { useLocation } from "react-router-dom";

import { Box, Button } from "@mui/material";

import useLayoutData from "@/hooks/useLayoutData";
import useThemeData from "@/hooks/useThemeData";
import { Nav } from "@/typings";

interface MobileNavBtnProps {
  data: Nav;
  onClick: (path: string) => void;
}

const MobileNavBtn = ({ data, onClick }: MobileNavBtnProps) => {
  const { mobileNavHeight } = useLayoutData();
  const location = useLocation();
  const isActive = (data.matches || []).includes(location.pathname);

  const theme = useThemeData();

  return (
    <Box
      onClick={() => onClick(data.path)}
      className="relative inline-flex items-center justify-center"
    >
      <Button
        variant="text"
        className="!py-[0] !px-[8px] m-[0] !min-w-[32px] !font-bold whitespace-nowrap"
        style={{ height: mobileNavHeight + "px" }}
        sx={{
          color: isActive
            ? theme.isDarkMode
              ? theme.palette.primary.main
              : "#fff"
            : theme.isDarkMode
            ? theme.palette.text.secondary
            : "rgba(255, 255, 255, 0.7)",
          ".MuiButton-startIcon": {
            marginRight: "1px",
          },
          ".MuiButton-startIcon .MuiSvgIcon-root": {
            fontSize: "14px",
          },
        }}
        startIcon={data?.specialIcon}
      >
        {data.name}
      </Button>

      {isActive ? (
        <Box
          className="absolute left-[8px] right-[8px] bottom-0 h-[3px]"
          sx={{
            borderRadius: "3px 3px 0 0",
            backgroundColor: theme.isDarkMode ? theme.palette.primary.main : "#fff",
          }}
        />
      ) : null}
    </Box>
  );
};

export default React.memo(MobileNavBtn);